import { Injectable, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InstantDataService {
  @Output() readonly dataAdded = new EventEmitter<{
    key: string;
    id: string;
    data: any;
  }>();

  data: Array<{ key: string; id: string; data: any }> = [];
  request: Array<{ key: string; context: string; id: string; data: any }> = [];

  private requestSubject = new Subject<{
    key: string;
    context: string;
    id: string;
    data: any;
  }>();
  request$ = this.requestSubject.asObservable();

  addRequest(key: string, context: string, id: string, data: any) {
    // Only allows one request per context
    const index = this.request.findIndex(r => r.context === context);
    if (index > -1) {
      this.request.splice(index, 1);
    }

    this.request.push({ key, context, id, data });
    this.requestSubject.next({ key, context, id, data }); // Trigger the subject
  }

  getRequest(context: string) {
    return this.request.find(r => r.context === context);
  }

  removeRequest(key: string) {
    const index = this.request.findIndex(r => r.context === key);

    if (index > -1) {
      this.request.splice(index, 1);
    }
  }

  addData(key: string, id: string, data: any) {
    this.data.push({ key, id, data });
    this.dataAdded.emit({ key, id, data });
  }

  getData(key: string, id: string) {
    const index = this.data.findIndex(d => d.key === key && d.id === id);

    if (index > -1) {
      const data = this.data[index].data;
      this.data.splice(index, 1);
      return data;
    }
    return null;
  }
}
